
import {
    defineComponent, PropType, ref, Ref
} from 'vue';
import { account as accountRequest } from '@/data/';
import HttpRequest from '@/util/axios.config';
import { setting as postalCodeRule } from '@/methods/rule';

interface FormData {
    ID: number;
    BillingTitle: string;
    Contactor: string;
    Street: string;
    City: string;
    Postcode: string;
    Country: string;
    TelePhone: string;
    Fax: string;
}
type UserType = 'property' | 'propertyCommunity'|'distributor' | 'installer';
export default defineComponent({
    props: {
        userType: {
            type: String as PropType<UserType>
        }
    },
    setup(props, { emit }) {
        const urls = ref('');
        const getFormData = () => {
            const formData: Ref<FormData> = ref({
                ID: 0,
                BillingTitle: '',
                Contactor: '',
                Street: '',
                City: '',
                Postcode: '',
                Country: '',
                TelePhone: '',
                Fax: ''
            });
            switch (props.userType) {
                case 'property':
                case 'propertyCommunity':
                    accountRequest.getPropertyBillingInfo((data: FormData) => { formData.value = data; });
                    urls.value = 'setpbillinfo';
                    break;
                case 'installer':
                    accountRequest.getInstallerBillingInfo((data: FormData) => { formData.value = data; });
                    urls.value = 'v3/web/common/manage/editBillingInfo';
                    break;
                case 'distributor':
                    accountRequest.getDistributorBillingInfo((data: FormData) => { formData.value = data; });
                    break;
                default:
                    break;
            }
            return formData;
        };
        const formData = getFormData();

        const submit = () => {
            HttpRequest.post(urls.value, formData.value, () => {
                emit('close');
                emit('success');
            });
        };

        const countryOption = addressOption;
        // const rules = {
        //     Postcode: [
        //         {
        //             validator: postalCodeRule.onlyNumberAndNotEmpty,
        //             trigger: 'blur'
        //         }
        //     ]
        // };

        return {
            urls,
            formData,
            submit,
            countryOption
        };
    }
});
